import type {
  DeleteFileResponse,
  Folder,
  Requirement,
} from "../../redux/interfaces/folder.types";

export function applyFileDeletionResponse(
  requirement: Requirement,
  response: DeleteFileResponse,
  requestedFileId: string,
): Requirement {
  if (response.requirement?.id === requirement.id) {
    return response.requirement;
  }

  const deletedFileIds = new Set(
    response.deleted_file_ids?.length
      ? response.deleted_file_ids
      : [requestedFileId],
  );
  const archivedFileIds = new Set(response.archived_file_ids ?? []);
  const restoredFileIds = new Set(response.restored_file_ids ?? []);

  return {
    ...requirement,
    ...(response.requirement_status
      ? { status: response.requirement_status }
      : {}),
    ...(response.workflow_step !== undefined
      ? { workflow_step: response.workflow_step }
      : {}),
    files: requirement.files
      .filter((file) => !deletedFileIds.has(file.id))
      .map((file) => {
        if (archivedFileIds.has(file.id)) {
          return { ...file, is_verification_reference: true };
        }
        if (restoredFileIds.has(file.id)) {
          return { ...file, is_verification_reference: false };
        }
        return file;
      }),
  };
}

export function replaceRequirementInFolder(
  folder: Folder,
  updatedRequirement: Requirement,
): Folder {
  return {
    ...folder,
    subfolders: folder.subfolders?.map((subfolder) => ({
      ...subfolder,
      requirements: subfolder.requirements?.map((requirement) =>
        requirement.id === updatedRequirement.id
          ? updatedRequirement
          : requirement,
      ),
    })),
  };
}
